import React from 'react';
import { Link } from 'react-router-dom';
import { List, Section, Strong } from './prose';

export default function TermsContent() {
  return (
    <div data-testid="terms-content">
      <Section title="About these terms">
        <p>
          These terms apply when you use the Coach Rands app at app.coachrands.com, including the free tracker and the
          strength calculator. The app is provided by Randal Harrison, trading as Coach Rands, a sole trader in the
          UK. By using the app you agree to these terms.
        </p>
      </Section>

      <Section title="General training information, not medical advice">
        <p>
          <Strong>
            The app gives general training information only. It is not medical advice, and it is not a diagnosis or
            treatment for any condition.
          </Strong>
        </p>
        <p>
          Strength estimates, charts, personal bests, plateau alerts and technique cues are general guidance based on
          the numbers you enter. They are not a substitute for advice from a doctor, physiotherapist or other qualified
          professional who knows your circumstances.
        </p>
      </Section>

      <Section title="You train at your own risk">
        <p>
          Weighted pull-ups and other strength training carry a risk of injury. <Strong>You train at your own
          risk.</Strong> You are responsible for:
        </p>
        <List
          items={[
            'choosing weights and rep targets you can handle safely;',
            'using a secure bar and safe, well-maintained equipment;',
            'warming up properly and stopping if something hurts.',
          ]}
        />
        <p>
          If you have a health condition, a past or current injury, or you are not sure whether this kind of training
          is right for you, check with a doctor before you start.
        </p>
      </Section>

      <Section title="If you are injured">
        <p>
          <Strong>
            If you feel pain, are injured, or have symptoms that worry you, stop training and get advice from a
            qualified health professional before you continue.
          </Strong>{' '}
          Do not rely on the app to assess or treat an injury. Logging discomfort in the app does not mean anyone
          has reviewed it.
        </p>
      </Section>

      <Section title="Your account">
        <p>
          You sign in with your email address. Keep your email account secure, because anyone who can open your login
          links can sign in to your Coach Rands account. You can delete your account at any time from the{' '}
          <Link to="/free/account" className="text-white underline">Account page</Link>.
        </p>
      </Section>

      <Section title="Using the app fairly">
        <p>
          Do not misuse the app. That includes trying to access other people&apos;s data, interfering with how the app
          works, or using it for anything unlawful.
        </p>
      </Section>

      <Section title="Availability and changes">
        <p>
          The free tracker is provided free of charge. We may change, pause or stop it at any time, and we cannot
          promise it will always be available or free from errors. We may update these terms. If we make a
          significant change, we will let you know in the app or by email.
        </p>
      </Section>

      <Section title="Limitation of liability">
        <p>
          Nothing in these terms limits or excludes our liability for death or personal injury caused by our
          negligence, for fraud or fraudulent misrepresentation, or for anything else that cannot be limited or
          excluded by law.
        </p>
        <p>Subject to that:</p>
        <List
          items={[
            'we are not liable for any injury, loss or damage caused by your training, by how you use the general information in the app, or by any weight, estimate or suggestion you choose to act on;',
            'we are not liable for losses that were not reasonably foreseeable, or for any business losses;',
            'we are not liable for losing data that you could have kept a copy of yourself.',
          ]}
        />
        <p>These terms do not affect your legal rights as a consumer.</p>
      </Section>

      <Section title="Privacy">
        <p>
          How we handle your data is explained in our <Link to="/privacy" className="text-white underline">Privacy notice</Link>.
        </p>
      </Section>

      <Section title="Law">
        <p>
          These terms are governed by the law of England and Wales. If you live in Scotland or Northern Ireland, you
          can also bring a claim in your local courts.
        </p>
      </Section>

      <Section title="Contact">
        <p>Email us at [CONTACT EMAIL].</p>
      </Section>
    </div>
  );
}
